module.exports = __webpack_public_path__ + "img/dq.5fa9560c.jpg";